<section>
  <ion-row class="header-row ion-align-items-center">
    <ion-col>
      <h3 class="popup-heading ml-15">
       Copy Task
      </h3>
    </ion-col>
    <ion-col size="auto">
      <button mat-icon-button mat-dialog-close class="close-btn">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </ion-col>
  </ion-row>

  <mat-dialog-content class="popup-content">
    <!-- Form Wrapper -->
    <div [formGroup]="skipDayForm" class="form-group">
      <h6>For which month do you want to paste this DWM?</h6>
      
      <mat-form-field class="w-100 mw-sm-200 mat mat-height40 mat-input-style mb-15">
        <mat-select formControlName="targetMonth" placeholder="Select Month">
          <mat-option *ngFor="let month of availableMonths" [value]="month.value">
            {{ month.label }}
          </mat-option>
        </mat-select>

        <mat-error *ngIf="skipDayForm.get('targetMonth')?.hasError('required')">
          Please select a month.
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Confirm Button -->
    <div class="submit-container">
      <button mat-flat-button color="primary" class="submit-btn" (click)="confirmSelection()">
        Confirm
      </button>
    </div>
  </mat-dialog-content>
</section>
